module.exports = __webpack_public_path__ + "img/Android.3ea4f87f.png";